import React from 'react';
import Header from '../containers/Header';
import MainSection from '../containers/MainSection';
import { connect } from 'react-redux';
import { addTodo, setFilteredTodos, setTodos } from '../actions';

const todoFromApi = ({ message, status }) => ({
	text: message,
	completed: status === 'COMPLETED'
});
class App extends React.Component {
	componentDidMount() {
		fetch('https://546fmypedf.execute-api.us-east-2.amazonaws.com/1/getTodos')
			.then(a => a.json())
			.then(({ todos }) => {
				this.props.setTodos(todos.map(todoFromApi));
				return todos;
			})
			.then(todos => {
				return fetch(
					'https://546fmypedf.execute-api.us-east-2.amazonaws.com/1/todoFilter',
					{
						method: 'POST',
						body: JSON.stringify({ todos, filter: '' })
					}
				);
			})
			.then(a => a.json())
			.then(this.props.setFilteredTodos); //.then(() =>fetch('https://546fmypedf.execute-api.us-east-2.amazonaws.com/1/filter));
	}

	render() {
		return (
			<div>
				<Header />
				<MainSection />
			</div>
		);
	}
}

export default connect(null, { addTodo, setFilteredTodos, setTodos })(App);



// WEBPACK FOOTER //
// ./src/components/App.js